export const headCellAccesoryProduct = [
  { id: "", disablePadding: false, label: "" },
  { id: "id", disablePadding: false, label: "Id" },
  { id: "barCode", disablePadding: false, label: "Código de barras" },
  { id: "provider", disablePadding: false, label: "Proveedor" },
  { id: "timeGuarantee", disablePadding: false, label: "Días de garantía" },
  { id: "cost", disablePadding: false, label: "Costo" },
  { id: "price", disablePadding: false, label: "Precio" },
  { id: "discount", disablePadding: false, label: "Descuento" },
  { id: "color", disablePadding: false, label: "Color" },
  { id: "createdAt", disablePadding: false, label: "Agregado el" },
  { id: "site", disablePadding: false, label: "Sucursal" },
];
